// extracted by mini-css-extract-plugin
export default {"logout":"Logout-module__logout__KbRDd","icon":"Logout-module__icon__6ltl7"};